// next
import { useRouter } from 'next/router';
// @mui
import { useState, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Box, AppBar, Toolbar, Container, Popover, MenuItem, Stack, Divider } from '@mui/material';
import NextLink from 'next/link';
// hooks
import useOffSetTop from 'src/hooks/useOffSetTop';
import useResponsive from 'src/hooks/useResponsive';
// utils
import cssStyles from '../../utils/cssStyles';
// config
import { HEADER } from '../../config';
// components
import Logo from 'src/components/Logo';
// import Label from 'src/components/Label';
//
import MenuDesktop from './MenuDesktop';
import MenuMobile from './MenuMobile';
import navConfig from './MenuConfig';
import Image from 'next/image';
import IconButtonAnimate from '@components/animate/IconButtonAnimate';
import Iconify from '@components/Iconify';
import useAuth from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  height: HEADER.MOBILE_HEIGHT,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('md')]: {
    height: HEADER.MAIN_DESKTOP_HEIGHT,
  },
}));

const ToolbarShadowStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  bottom: 0,
  height: 24,
  zIndex: -1,
  margin: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  width: `calc(100% - 48px)`,
  boxShadow: theme.customShadows.z8,
}));

// ----------------------------------------------------------------------

export default function MainHeader() {
  const isOffset = useOffSetTop(HEADER.MAIN_DESKTOP_HEIGHT);
  const theme = useTheme();
  const { user, isAuthenticated, logout } = useAuth();
  const { pathname, push } = useRouter();
  const [anchorEl, setAnchorEl] = useState(null);

  const isDesktop = useResponsive('up', 'md');

  const isHome = pathname === '/';

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  }

  return (
    <AppBar sx={{ boxShadow: 0, bgcolor: 'transparent' }}>
      <ToolbarStyle
        disableGutters
        sx={{
          ...(isOffset && {
            ...cssStyles(theme).bgBlur(),
            height: { md: HEADER.MAIN_DESKTOP_HEIGHT - 16 },
          }),
        }}
      >
        <Container
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {!isDesktop && <MenuMobile isOffset={isOffset} isHome={isHome} navConfig={navConfig} />}
          <Box sx={{ flexGrow: 1, display: { xs: 'block', sm: 'block', md: 'none', lg: 'none', xl: 'none' } }} />
          <Logo />

          {/* <Label color="info" sx={{ ml: 1 }}>
            v3.0.0
          </Label> */}
          <Box sx={{ flexGrow: 1 }} />

          {!isDesktop && <>
          {isAuthenticated ? <p style={{cursor: 'pointer'}} onClick={handleClick}>{user?.username}</p> : <IconButtonAnimate
            onClick={() => push('/dashboard/app')}
            sx={{
              ml: 1,
              ...(isHome && { color: 'common.white' }),
              ...(isOffset && { color: 'text.primary' }),
            }}
          >
            <Iconify icon={'eva:person-fill'} />
          </IconButtonAnimate>}
            <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            anchorPosition={{ top: 80, left: 0 }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={handleClose}
            sx={{
              p: 0,
              mt: 1.5,
              ml: 0.75,
              '& .MuiMenuItem-root': {
                borderRadius: 0.75,
              },
            }}
          >
            <Stack sx={{ p: 1 }}>
              <NextLink href={'/dashboard/app'} passHref>
                <MenuItem>
                  Go To Dashboard
                </MenuItem>
              </NextLink>
            </Stack>

            <Divider sx={{ borderStyle: 'dashed' }} />
            <Stack sx={{ p: 1 }}>
              <MenuItem onClick={logout}>
                Logout
              </MenuItem>  
            </Stack>
          </Popover>
          </>}

          {isDesktop && <MenuDesktop isOffset={isOffset} isHome={isHome} navConfig={navConfig} />}


        </Container>
      </ToolbarStyle>

      {isOffset && <ToolbarShadowStyle />}
    </AppBar>
  );
}
